import { render, staticRenderFns } from "./TreeChart.vue?vue&type=template&id=4fb1533e&scoped=true"
import script from "./TreeChart.vue?vue&type=script&lang=js"
export * from "./TreeChart.vue?vue&type=script&lang=js"
import style0 from "./TreeChart.vue?vue&type=style&index=0&id=4fb1533e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1533e",
  null
  
)

export default component.exports